<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },
});

const emit = defineEmits(['click']);

function onButtonClick(event) {
  emit('click', event);
}
</script>

<template>
  <button class="ui-button-main" :type="props.type" @click="onButtonClick">
    <img
      src="/icons/icon_arrow_top.svg"
      alt="arrow"
      class="ui-button-main__icon ui-button-main__icon--arrow"
    />
  </button>
</template>

<style lang="scss" scoped>
.ui-button-main {
  $parent: &;

  display: flex;
  align-items: center;
  justify-content: center;
  width: em(32);
  height: em(32);
  background-color: rgba($color-white, 0.8);
  border-radius: 50%;
  transition: background-color ease-out $time-fast;

  @include hover-active-focus {
    background-color: $color-white;
  }

  @include media-breakpoint-down(md) {
    width: em(25);
    height: em(25);
  }

  @include media-breakpoint-down(sm) {
    width: em(32);
    height: em(32);
  }

  &__icon {
    &--arrow {
      width: em(16);
      height: em(16);

      @include media-breakpoint-down(md) {
        width: em(13);
        height: em(13);
      }

      @include media-breakpoint-down(SM) {
        width: em(16);
        height: em(16);
      }
    }
  }
}
</style>
